<template>
    <basic-container>
        <div class="invest-form-container">
            <div class="inner-con">
                <div class="project-title">{{basicInfoData.blReportStandard?basicInfoData.blReportStandard.name:''}}</div>
                <div class="project-status">
                    <div class="status-title">审批状态</div>
                    <div class="status-content" :class="['stateTopdiv', 'color_' + basicInfoData.auditStatus]">
                        {{basicInfoData.auditStatusStr}}
                    </div>
                </div>
            </div>

            <el-tabs v-model="activeName">
                <el-tab-pane class="activelabel" label="投放申请单" name="first">
                    <DetailForm
                        style="margin-top: 20px;"
                        ref="commonForm"
                        :id="id"
                        :isDetail="true"
                        :bindData="basicInfoData"
                    />

                    

                    <!-- 流程公共附件 -->
                    <Accessory
                        v-loading="!dataReady"
                        element-loading-text="加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(153, 153, 153, 0.8)"
                        v-if="uploadPermissionNameOne && uploadPermissionNameTwo"
                        :idname="uploadPermissionNameTwo"
                        :fileMenuUrlname="uploadPermissionNameOne"
                        :projectid="basicInfoData.projectInfoId"
                        :dynamicId="id"
                        :upload="true"
                        :permissionList="permissionList"
                        :isPermission="true"
                    />

                    
                    <!-- 流程设计相关组件相关数据存储在workflow.js中 -->
                    <!-- 流程设计审批信息表单 -->
                    <AuditInfo
                        ref="auditInfo"
                        v-loading="!dataReady"
                        element-loading-text="加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(153, 153, 153, 0.8)"
                        v-if="isStartedProcess && auditFormData && auditFormData != {}"
                        :formDetailData="auditFormData"
                        :isEditable="processDetail.process?processDetail.process.isEditable:false"
                        :status="(processDetail.process && processDetail.process.status)?processDetail.process.status: 'done'"
                    />
                    <!-- 会签意见区 -->
                    <CommentStep
                        v-loading="!dataReady"
                        element-loading-text="加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(153, 153, 153, 0.8)"
                        v-if="commentList.length > 0"
                        :commentList="commentList"
                        :taskSaveData="taskSaveData"
                        :taskNo="processDetail.process?Number(processDetail.process.taskNo): 0"
                        :status="(processDetail.process && processDetail.process.status)?processDetail.process.status: 'done'"
                    />
                    <!-- 流程记录  -->
                    <CommentTable
                        v-loading="!dataReady"
                        element-loading-text="加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(153, 153, 153, 0.8)"
                        v-if="flowData.length>0"
                        :flowData="flowData"
                    />

                    <!-- 会签意见区 -->
                    <InfoContainer
                        v-if="!isStartedProcess"
                        class="comment-container"
                        style="margin-top:20px;"
                        :infoTitle="commentBlockConfig['infoTitle']"
                        :contentConfig="commentBlockConfig['infoContent']"
                    >
                        <template #comment>
                            <CommentBlock
                                ref="commentBlock"
                                @fileChange="fileChange"
                                :id='id'
                            />
                        </template>
                    </InfoContainer>
                </el-tab-pane>

                <!-- v-if="basicInfoData.auditStatus == 2" -->
                <!-- <el-tab-pane  label="放款详情" name="second" v-if="basicInfoData.auditStatus == 2">
                    <Lending 
                        v-if="basicInfoData.id"
                        :investBatch="basicInfoData.investBatch"
                        :investId="basicInfoData.id"
                        :investData="basicInfoData"
                    />
                </el-tab-pane> -->

                <el-tab-pane v-if="isStartedProcess" label="流程跟踪" name="second">
                    <template v-if="activeName == 'second'">
                        <el-card shadow="never" style="margin-top: 5px;">
                            <wf-design ref="bpmn" style="height: 500px;" :options="bpmnOption"></wf-design>
                        </el-card>
                    </template>
                </el-tab-pane>
            </el-tabs>
            <!-- <DetailForm /> -->
        </div>

        <!-- 1.流程状态为todo时 2.提交状态为未提交可编辑时显示底部操作按钮-->
        <BottomLine
            ref="bottomLine"
            :auditState="basicInfoData.auditStatus"
            :processDetail="processDetail"
            :isStartedProcess="isStartedProcess"
            :goEdit="!isStartedProcess||(workFlowState && workFlowState.isFirstFlowPermission&&isStartedProcess)"
            @goEdit="goEdit"
            @buildNewOne="buildNewOne"
            @startProcess="saveProject(true)"
            @saveTask="saveTask"
            @saveProject="saveProject"
            @flowNext="flowNext"
            @openPrintForm="goPrint"
            @refreshData="refreshData"
        />
    </basic-container>
</template>
<script>
import { queryInvestLoanDetail, getInvestPocessName, addInvestLoan } from '@/api/factoring/factoring'
import DetailForm from "./components/form"
import Lending from "./components/lending"
import InfoContainer from "@/components/infoContainer/infoContainer"

// 工作流相关组件
import Accessory from "@/components/accessoriesother/accessoryFactor"
import AuditInfo from "@/components/workflowComponents/auditInfo/auditInfo"
import CommonSelect from "@/components/commonSelect/commonSelect"
import CommentStep from "@/components/workflowComponents/commentStep/commentStep"
import CommentTable from "@/components/workflowComponents/commentTable/commentTable"
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import BottomLine from "@/components/workflowComponents/bottomLine/bottomLine"
import workFlow from "@/mixins/workFlow";
import { mapGetters } from "vuex";
export default {
    name: 'EditInvestmentLoanDetailForm',
    mixins: [workFlow],
    data() {
        return {
            id: "",
            basicInfoData: {
                projectInfoId:''
            },
            activeName: "first",
            processKey: 'bl_project_placement',
            detailFormUrl: '/factoring/InvestmentLoanManagement/investmentLoanDetail', 
            attchmentList: []
        }
    },
    components: {
        InfoContainer,
        Accessory,
        AuditInfo,
        CommentStep,
        CommentTable,
        BottomLine,
        CommonSelect,
        CommentBlock,
        DetailForm,
        Lending
    },
    computed: {
        ...mapGetters(["workFlowData","workFlowState","userInfo"])
    },
    mounted() {
        this.id = this.$route.params.id
        this.queryInvestDetail(this.id)
    },
    methods: {
        goEdit() {
            this.$router.push({
                path: `/factoring/InvestmentLoanManagement/editInvestmentLoan/${this.id}`,
            });
        },
        async queryInvestDetail(id) {
            let res = await queryInvestLoanDetail({ id })
            if(res.data.code == 200) {
                this.basicInfoData = res.data.data
                // this.getBasicConfigData()

                // 查询流程数据
                this.$store.commit('SET_WORKFLOW_STATE', {state: this.basicInfoData.auditStatus})
                if(res.data.data && res.data.data.flowableId) {
                    this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
                    this.queryProcessFormDetail(this.processDefinedId)
                    this.isStartedProcess = true
                    // 集成在workFlow.js中
                    await this.queryFlowData(res.data.data.flowableId)
                } else {
                    // 未启动流程 查询第一个节点的文件上传权限
                    this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
                    this.permissionList = await this.queryTaskUploadDetail(this.processDefinedId, '', true)
                    // 设置流程表单路径
                    this.queryProcessFormDetail(this.processDefinedId)
                }
            }
        },

        async getBasicConfigData() {
            this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
            // 获取当前流程文件上传列表权限 permissionList
            this.permissionList = await this.queryTaskUploadDetail(this.processDefinedId, '', true)
            // 设置流程表单路径
            this.queryProcessFormDetail(this.processDefinedId)
        },        

        fileChange(fileList) {
            let self = this
            if(fileList.length > 0) {
                this.attchmentList = []
                fileList.map(item => {
                    self.attchmentList.push({
                        name: item.name,
                        url: item.response.data.link
                    })
                })
            }
        },

        // 保存尽调数据
        async saveTask() {
            let taskId = this.processDetail.process.taskId
            // 从vuex中获取
            let comment = this.workFlowData.opinionContent
            // let attachmentList = this.workFlowData.attchmentList

            // 流程表单数据
            let customData = this.$refs.auditInfo.commentDetail
            let formData = this.$refs.auditInfo.$data.formData

            let variables = this.dealAuditForm(formData, customData)
            // 保存数据存储在variables中
            variables[`comment_${taskId}`] = comment
            // variables[`attachment_${taskId}`] = attachmentList

            let saveRes = await this.flowSaveTask(variables)
            // 刷新数据
            this.saveTask = {
                comment: '',
                attachment: []
            }
            this.queryInvestDetail(this.id)
            this.$forceUpdate()
        },

        // 流程流转
        async flowNext(taskInfoList) {
            let processInsId = this.processDetail.process.processInstanceId
            let taskId = this.processDetail.process.taskId
            let taskName = this.processDetail.process.taskName

            // 流程表单数据
            let valid = this.$refs.auditInfo.validData()
            if(valid){
                let customData = this.$refs.auditInfo.commentDetail
                let formData = this.$refs.auditInfo.$data.formData

                let variables = this.dealAuditForm(formData, customData)
                if(taskInfoList){
                    await this.selectPeopleFlowNext(
                        taskId,
                        taskName,
                        this.workFlowData.attchmentList?this.workFlowData.attchmentList:[],
                        this.workFlowData.opinionContent?this.workFlowData.opinionContent:'',
                        variables,
                        JSON.stringify(taskInfoList),
                    )
                
                }else {
                    await this.taskFlowNext(
                        taskId,
                        processInsId,
                        this.workFlowData.attchmentList?this.workFlowData.attchmentList:[],
                        this.workFlowData.opinionContent?this.workFlowData.opinionContent:'',
                        variables
                    )
                }

                // 刷新数据
                this.queryInvestDetail(this.id)
                this.$forceUpdate()
            }
        },
        refreshData(){
           this.queryInvestDetail(this.id)
        },
        async saveProject(startProcess) {
            if(this.basicInfoData.managerUser == this.userInfo.user_id || this.basicInfoData.assistUser == this.userInfo.user_id ) {
                let { custId, reportId, name, selectId, projectName} = this.$refs.commonForm.$data.formOneData
                let { 
                    rentId,
                    contractId,
                    netInvestAmount,
                    bankId,
                    otherCondition,
                    rentDate,
                    isInvestCondition,
                    investCredit
                } = this.$refs.commonForm.$data.formTwoData
                let saveParams = {
                    id: this.id,
                    flowableId: this.basicInfoData.flowableId?this.basicInfoData.flowableId: '',
                    accountingEntity: 1,
                    custId,
                    reportId: reportId?reportId: selectId,
                    rentId,
                    contractId: contractId?contractId: this.$refs.commonForm.$data.formTwoData.selectId,
                    bankId,
                    projectName: name?name:projectName,
                    thisInvestMoney: investCredit,
                    isInvestCondition,
                    rentDate,
                    cleanMoney: netInvestAmount,
                    investOutlays: this.$refs.commonForm.$data.tableData,
                    remarks: otherCondition
                }            
                // 启动流程按钮， 先绑定flowableId 后保存
                if(startProcess) {
                    let redirectInfo ={
                        url: this.detailFormUrl,
                        id: this.id
                    }
                    let processNameRes = await getInvestPocessName(saveParams) 
                    let params = {
                        detailFormUrl:  JSON.stringify(redirectInfo),
                        processId: this.processDefinedId,
                        comment: this.$refs.commentBlock.$data.opinionContent,
                        attachmentList: this.attchmentList,
                        processInstanceName: processNameRes.data.data.processInstanceName,
                        riskExposure: Number(this.basicInfoData.factoringCredit)
                    }
                    let processInsId = await this.startWorkFlowProcess(params)
                    saveParams.flowableId = processInsId
                }
                let res = await addInvestLoan(saveParams)
                if(res.data.code == 200){
                    this.queryInvestDetail(this.id)
                    // 跳转到详情页
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    })
                }
            } else {
                this.$message.warning('您非该投放数据创建者或协办者暂无权限进行次操作')
            }

        },

    }
}
</script>
<style lang="scss" scoped>
.invest-form-container{
    background-color: #fff;
    overflow: hidden auto;
    padding: 15px !important;
    padding-bottom: 30px !important;
    min-width: 1000px;
    max-width: 1100px;
    margin: 0 auto;   
    .inner-con{
        // min-width: 1000px;
        // max-width: 1100px;
        margin-top: 3px;
        .project-name{
        // overflow: hidden;
        // white-space: nowrap;
        // text-overflow: ellipsis;
            color: #409EFF;
        }
        .project-name:hover{
            color: #409EFF;
            cursor: pointer;
        }
        .project-title{
            color: #333;
            font-size: 18px;
            font-weight: bold;
        }
        .project-status{
            .status-title{
                text-align: right;
                font-family: '微软雅黑', sans-serif;
                font-weight: 400;
                color: #999999;
                font-size: 14px;
            }
            .status-content{
                text-align: right;
                font-family: '微软雅黑', sans-serif;
                font-weight: 400;
                color: #666666;
                font-size: 20px;
            }
        }
    }

    .comment-container{
        margin-top: 20px;
        /deep/.detail-one{
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }
        /deep/.comment-container{
            margin-top: 0 !important;
        }
    }    

    .stateTopdiv::before {
        content: "";
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 5px;
    }
    .color_0::before {
        background: #fec03d;
    }
    .color_1::before {
        background: #409eff;
    }
    .color_2::before {
        background: #51d351;
    }
    .color_3::before {
        background: #F56C6C;
    }
    .color_4::before {
        background: #F56C6C;
    }

    /deep/.el-tabs__item {
        font-size: 18px ;
        font-weight: bolder ;
        margin-bottom: 10px ;
    }
    /deep/.el-tabs__item.is-active {
        background: none;
    }
    /deep/.el-tabs__header {
        margin: 0px;
    }
}
</style>